import HeaderBadgeTrigger from './HeaderBadgeTrigger';
export default HeaderBadgeTrigger;